import { FileBarChart, Search, Users, Eye } from 'lucide-react'
import { SidebarSection } from './sidebar-section'
import { SidebarItem } from './sidebar-item'

interface AnalyticsSectionProps {
  sidebarCollapsed: boolean
  onItemClick: () => void
}

export function AnalyticsSection({ sidebarCollapsed, onItemClick }: AnalyticsSectionProps) {
  const analyticsItems = [
    { name: 'Account Search', href: '/search', icon: Search },
    { name: 'Account Analytics', href: '/request-analytics', icon: FileBarChart },
    { name: 'Custom Watchlists', href: '/watchlists', icon: Eye },
    { name: 'Global Accounts', href: '/global-accounts', icon: Users },
  ]

  return (
    <SidebarSection
      title="IG Analytics"
      icon={<FileBarChart className="h-4 w-4" />}
      sidebarCollapsed={sidebarCollapsed}
      defaultOpen={true}
    >
      {analyticsItems.map((item) => (
        <SidebarItem
          key={item.name}
          name={item.name}
          href={item.href}
          icon={item.icon}
          sidebarCollapsed={sidebarCollapsed}
          onClick={onItemClick}
        />
      ))}
    </SidebarSection>
  )
}
